import React, { useCallback } from "react";

import { Field } from "redux-form";
import PropTypes from "prop-types";
import classNames from "classnames";

import { ReduxControls, Icon } from "rhombus-react";
import { REDDIT_IMAGE_CONSTRAINTS } from "./validators/reddit";
import { nonDynamicFields } from "social/utils";

import "./RedditDisclaimer.css";

const DISCLAIMER_TEXT_PLACEHOLDER = "This is a disclaimer text entered by the user. Either disclaimer text or disclaimer URL is required";

export default function RedditDisclaimer(props){
	const {
		input: { value, onChange } = {},
		disabled = false,
		className = "",
		showPristineErrors,
	} = props;

	const onToggleChange = useCallback((e) => {
		e.stopPropagation();
		if(!disabled){
			onChange(!value);
		}
	}, [disabled, onChange, value]);


	return (
		<div
			className={classNames("reddit-disclaimer-wrapper", "e-form__control-wrapper", {
				[className]: !!className,
			})}
		>
			<div className="full-width e-form__control-header">
				<div
					className={classNames({
						"reddit-disclaimer-field": true,
						"is-checked": !!value,
					})}
					onClick={onToggleChange}
					disabled={disabled}
				>
					<div className="reddit-disclaimer-slider" />
				</div>
				<div className="e-form__control-label">
					Disclaimer&nbsp;
					<Icon name="help-tip fas fa-info-circle" data-tip="Adding disclaimers to your ads could help you avoid legal risks." />
				</div>
			</div>
			{!!value && (
				<div className="full-width">
					<div className="reddit-disclaimer-body">
						<Field
							name="disclaimerText"
							key="disclaimerText"
							label="Disclaimer Text"
							className="reddit-disclaimer-textarea"
							component={ReduxControls.Input}
							type="textarea"
							placeholder={DISCLAIMER_TEXT_PLACEHOLDER}
							disabled={disabled}
							charMax={REDDIT_IMAGE_CONSTRAINTS.MAX_LENGTH_DISCLAIMER_TEXT}
							showCharCount
							required
							showPristineErrors={!!showPristineErrors}
							{...nonDynamicFields()}
						/>
					</div>
				</div>
			)}
		</div>
	);
}

RedditDisclaimer.displayName = "RedditDisclaimer";

RedditDisclaimer.propTypes = {
	input: PropTypes.shape({
		value: PropTypes.any,
		onChange: PropTypes.func,
	}),
	disabled: PropTypes.bool,
	className: PropTypes.string,
	showPristineErrors: PropTypes.bool,
};
